import { render, staticRenderFns } from "./CourceCoursesSelect.vue?vue&type=template&id=6f05edc1&scoped=true"
import script from "./CourceCoursesSelect.vue?vue&type=script&lang=js"
export * from "./CourceCoursesSelect.vue?vue&type=script&lang=js"
import style0 from "./CourceCoursesSelect.vue?vue&type=style&index=0&id=6f05edc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05edc1",
  null
  
)

export default component.exports